import axios from 'axios';
import { takeEvery, call, put } from 'redux-saga/effects';
import * as types from './types';
import config from '../../config/app_config';
import { getClient } from '../../common/utils';

export function* deletePerkServiceWatcherSaga() {
  yield takeEvery(types.DELETE_PERK_SERVICE_CALL_REQUEST, workerSaga);
}

export function deleteData(offer) {
  const client = getClient();
  const url = `${config.API_ROOT_URL}/v1/offer/${client}/perkservice/${offer.slug}/`;

  return axios.delete(url)
    .then(val => val)
    .catch(err => err.response);
}

export function* workerSaga(action) {
  try {
    const { offer } = action;
    const response = yield call(deleteData, offer);

    if (response && response.status === 204) {
      yield put({ type: types.DELETE_PERK_SERVICE_CALL_SUCCESS });
      yield put({ type: types.GET_PERK_SERVICE_CALL_REQUEST });
    } else {
      yield put({ type: types.DELETE_PERK_SERVICE_CALL_FAILURE, error: response && response.data });
    }
  } catch (error) {
    yield put({ type: types.DELETE_PERK_SERVICE_CALL_FAILURE, 'error': error && error.data});
  }
}
